import { useTranslation } from 'react-i18next';

import { config } from 'app/config';
import { Button, Place } from './lang-selector.styled';
const langs = [
  { code: 'ru', title: 'RU' },
  { code: 'kk', title: 'KZ' },
  { code: 'ar', title: 'AR' },
  { code: 'en', title: 'EN' },
];

export const LangSelector = (props) => {
  const { i18n } = useTranslation();
  //console.log('🚀 ~ LangSelector ~ i18n.language', i18n.language);
  if (!config.use_lang) {
    return null;
  }

  const changeLang = (code) => {
    i18n.changeLanguage(code);
    localStorage.setItem('lang', code);
  };

  const buttons = langs.map((el, idx) => {
    let cl = i18n.language === el.code ? 'active' : '';

    return (
      <Button className={cl} onClick={() => changeLang(el.code)} key={idx} title={el.title}>
        {el.title}
      </Button>
    );
  });
  const cl2 = props.abs ? '' : 'noabs';

  return <Place className={cl2}>{buttons}</Place>;
};

LangSelector.defaultProps = {
  abs: true,
};
